const ceoQueue = {
  waiting: "Waiting",
  inProgress: "In Progress",
  forReview: "For Review",
  empty: "Queue is empty",
  openInNotion: "Open in Notion",
  queueTab: "Queue",
  updatesTab: "Updates",
  noUpdates: "No pending updates",
  readyForReview: "Ready for your review",
  questionsForYou: "Claude has questions",
} as const;
export default ceoQueue;
